import React from 'react'
import moment from 'moment-timezone'
const DateField = (props) => {
    const {lesson, format = 'MMM Do, hh:mm a', ...otherProps} = props
    return (
        <span title={moment(lesson?.startDate).format('LLLL')} {...otherProps}>{moment(lesson?.startDate).format(format)}</span>
    )
}

export default DateField